<template>
  <button-line
    :items="items"
    v-bind="$attrs"
  ></button-line>
</template>

<script>
import ButtonLine from '../../components/Parts/ButtonLine';

/**
 * Component ExpertToolButtonLine.vue
 *
 * @module ExpertToolButtonLine
 * @date
 * @author
 * @copyright UniWeb bvba 2022
 *
 * @link https://gitlab.uniweb.be/cor/4.04-caregiver-dashboard
 *
 * @coropreventionSW [SW-4.9] app/src/APP_DASHBOARD/templates/views/ExpertTool/ExpertToolButtonLine.vue
 * @see https://docs.google.com/document/d/1iOpHH151s_ABr-DniJIc__q-GHpXJJVq/edit#heading=h.a0z8d9xd3xr7
 *
 */

export default {
  name: 'ExpertToolButtonLine',
  components: {
    ButtonLine,
  },
  computed: {
    items() {
      return [
        {
          label: this.$ucfirst(this.$t('pa.weeklySportsGoal')),
          route: { name: 'PatientExpertToolSportsGoal' },
        },
        {
          label: this.$ucfirst(this.$t('expertTool.safetyPrecautions')),
          route: { name: 'PatientExpertToolSafetyPrecautions' },
        },
        // Note: Release 2.0 scope reduction
        // {
        //   label: this.$ucfirst(this.$t('expertTool.history')),
        //   route: { name: 'PatientExpertToolHistory' },
        // },
      ];
    },
  },
};
</script>
